/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';

import { uploadAdministrators, getCsvAdminUsersModel } from '../app/store/actions/adminUsers';
import UploadFilesComponent from '../components/upload';
import AdminUsersImportErrors from '../components/upload/AdminUsersImportErrors';
import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';

class UploadAdministratorsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
  }

  sendFile = async (file) => {
    await this.setState({ errors: {} });
    const result = await this.props.uploadAdministrators(file);
    await this.setState({ errors: (result && result.errors) || [] });
  }

  modelDownload = async () => {
    await this.props.getCsvAdminUsersModel();
  }

  goBack = () => {
    history.push(ROUTES.ADMIN_USERS);
  }

  
  render() {
    const { errors } = this.state;

    return (
      <div className="main-div-tables">
        <div className="main-table">
          <h2><Translate value="importAdministrators" /></h2>

          <div className="upload-text">
            <p><strong><Translate value="importText1" /></strong></p>
            <p><Translate value="importText2" /></p>
            <p><Translate value="importText3" /></p>
            <p><Translate value="importText4" /></p>
            <p><Translate value="adminUserImportText1" /></p>
            <p><Translate value="adminUserImportText2" /></p>
            <p><Translate value="adminUserImportText3" /></p>
            <ol>
              <li><Translate value="adminUserOptionProfile1" /></li>
              <li><Translate value="adminUserOptionProfile2" /></li>
              <li><Translate value="adminUserOptionProfile3" /></li>
            </ol>
          </div>

          <UploadFilesComponent
            sendFile={this.sendFile}
            goBack={this.goBack}
            modelDownload={this.modelDownload}
            itemsErrors={<AdminUsersImportErrors errors={errors} />}
          />

        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  uploadAdministrators: file => dispatch(uploadAdministrators(file)),
  getCsvAdminUsersModel: () => dispatch(getCsvAdminUsersModel()),
});

export default connect(null, mapDispatchToProps)(UploadAdministratorsPage);
